import { useEffect } from 'react';

/**
 * Directly sets document meta tags for SEO.
 * More reliable than react-helmet-async for SPA page-level overrides.
 */
const usePageSEO = ({ title, description, keywords, canonical, ogTitle, ogDescription, ogUrl, jsonLd }) => {
  useEffect(() => {
    // Title
    if (title) document.title = title;

    const setMeta = (attr, key, value) => {
      if (!value) return;
      let el = document.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute('content', value);
    };

    if (description) setMeta('name', 'description', description);
    if (keywords) setMeta('name', 'keywords', keywords);
    if (ogTitle) setMeta('property', 'og:title', ogTitle);
    if (ogDescription) setMeta('property', 'og:description', ogDescription);
    if (ogUrl) setMeta('property', 'og:url', ogUrl);

    // Canonical
    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', canonical);
    }

    // JSON-LD
    if (jsonLd) {
      const existingScript = document.querySelector('script[data-page-seo="true"]');
      if (existingScript) existingScript.remove();
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-page-seo', 'true');
      script.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }

    // Cleanup on unmount - restore defaults
    return () => {
      document.title = 'Haartransplantation Mönchengladbach | FUE Saphir, DHI & Long Hair FUE | Dion Hair Clinic';
      const defaultDesc = 'Haartransplantation in Mönchengladbach ab 2.999€. FUE Saphir, DHI & Long Hair FUE. Bart- & Augenbrauentransplantation. Ratenzahlung ab 53€/Monat. Kostenlose Beratung.';
      const descEl = document.querySelector('meta[name="description"]');
      if (descEl) descEl.setAttribute('content', defaultDesc);
      const canonicalEl = document.querySelector('link[rel="canonical"]');
      if (canonicalEl) canonicalEl.setAttribute('href', 'https://dionhairclinic.de/');
      const pageScript = document.querySelector('script[data-page-seo="true"]');
      if (pageScript) pageScript.remove();
    };
  }, [title, description, keywords, canonical, ogTitle, ogDescription, ogUrl, jsonLd]);
};

export default usePageSEO;
